export default "__VITE_ASSET__CX7Lsj4$__"